import type { Role, RoleModificators } from '@/domain/env/schemas';
import type { CompanyCapabilities } from '@/domain/companies/schemas';
import { roleModel } from '@/domain/env/role.select';
import { hasVendorExpenses } from '@/domain/companies/queries/capabilities.select';

export type CompanyDashboardAccessValues = {
  readonly role: Role | null;
  readonly roleModificators: Pick<RoleModificators, 'restricted'>;
  readonly capabilities: Pick<CompanyCapabilities, 'dynamic_features'>;
};

export type CompanyDashboardAccessContext = {
  readonly hasVendorExpenses: boolean;
  readonly isRestricted: boolean;
};

export const companyDashboardAccessContext = ({
  role,
  roleModificators,
  capabilities,
}: CompanyDashboardAccessValues): CompanyDashboardAccessContext => ({
  hasVendorExpenses: hasVendorExpenses(capabilities),
  isRestricted: roleModel.isRestricted({ role, restricted: roleModificators.restricted }),
});
